"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MsgRestrictionView = void 0;
class MsgRestrictionView {
    constructor(init) {
        Object.assign(this, init);
    }
}
exports.MsgRestrictionView = MsgRestrictionView;
